import * as actionTypes from './actionTypes';
import * as actions from './index';
import { updateObject } from '../utility';


export const adminSaveUserStart = () => {
    return {
        type: actionTypes.ADMIN_SAVE_USER_START
    };
};

export const adminSaveUserSuccess = (user) => {
    return {
        type: actionTypes.ADMIN_SAVE_USER_SUCCESS,
        payload: {user: user,lastaction:'saveuser'}
    };
};

export const adminSaveUserFail = (error) => {
    return {
        type: actionTypes.ADMIN_SAVE_USER_FAIL,
        error: error
    };
};

export const adminSaveNewUserStart = () => {
    return {
        type: actionTypes.ADMIN_SAVE_NEW_USER_START
    };
};

export const adminSaveNewUserSuccess = (user) => {
    return {
        type: actionTypes.ADMIN_SAVE_NEW_USER_SUCCESS,
        payload: {user: user,lastaction:'savenewuser'}
    };
};

export const adminSaveNewUserFail = (error) => {
    return {
        type: actionTypes.ADMIN_SAVE_NEW_USER_FAIL,
        error: error
    };
};

export const adminDeleteUserStart = () => {
    return {
        type: actionTypes.ADMIN_DELETE_USER_START
    };
};

export const adminDeleteUserSuccess = (userid) => {
    return {
        type: actionTypes.ADMIN_DELETE_USER_SUCCESS,
        payload: {user: userid,lastaction:'deleteuser'}
    };
};

export const adminDeleteUserFail = (error) => {
    return {
        type: actionTypes.ADMIN_DELETE_USER_FAIL,
        error: error
    };
};


export const adminGetUsersStart = () => {
    return {
        type: actionTypes.ADMIN_GET_USERS_START
    };
};

export const adminGetUsersSuccess = (users) => {
    return {
        type: actionTypes.ADMIN_GET_USERS_SUCCESS,
        payload: { users: users }
    };
};

export const adminGetUsersFail = (error) => {
    return {
        type: actionTypes.ADMIN_GET_USERS_FAIL,
        error: error
    };
};
export const adminGrantingReadSuccess = (granting) => {
    return {
        type: actionTypes.ADMIN_SET_GRANTING,
        payload: {granting: granting}
    }
}
export const adminGetAllGrantsSuccess = (grants) => {
    return {
        type: actionTypes.ADMIN_SET_ALL_GRANTS,
        payload: {grants: grants}
    }
}
export const adminGetAllGrantsStart = () => {
    return {
        type: actionTypes.ADMIN_GET_ALL_GRANTS_START
    }
}

export const adminGetAllGrantsFail = () => {
    return {
        type: actionTypes.ADMIN_GET_ALL_GRANTS_FAIL
    }
}

export const adminSetEditUser = (user) => {
    return {
        type: actionTypes.ADMIN_SET_EDITUSER,
        payload: {user: user}
    }
}

export const adminGetAllGrants = () => {
    return dispatch => {
        dispatch(adminGetAllGrantsStart());
        window.flow.grantingGetDefined().then(res => {
            console.log(res);
            dispatch(adminGetAllGrantsSuccess(res));
        }).catch( (res) => {
            console.log(res);
            dispatch(adminGetAllGrantsFail());
        })
    }
}

export const adminGetUsers = () => {
    return dispatch => {
        dispatch(adminGetUsersStart());
        window.flow.getUsersByFields().then((res) => {
            dispatch(adminGetUsersSuccess(res.user.elements));
            window.flow.grantingRoleGetAll().then(res => {
                console.log(res);
                dispatch(adminGrantingReadSuccess(res));
            })
        }).catch(res => {
            console.log(res);
            dispatch(adminGetUsersFail(res));
        })
    }
}

export function adminSaveUser(userData, messages) {
    console.log(userData);
    return dispatch => {  
        dispatch(adminSaveUserStart());      
           //window.flow.grantingUserSetRole(group, user, role).then((res) => {
           window.flow.userSetData( userData.id, { id:userData.id, username:userData.username, email:userData.email, metadata: {first_name: userData.first_name, last_name: userData.last_name}}).then((res) => {
               console.log(res);
               let user = {
                   ...res.user.data,
                   email: res.user.email,
                   first_name: res.user.first_name,
                   last_name: res.user.last_name,
               };
               user.role = userData.role;
               dispatch(adminSaveUserSuccess(user));

              if(userData.password !== '') {
                  window.flow.userSetPassword( userData.id, userData.password);
              }
              window.flow.grantingUserSetRole(res.groupid, res.userid, userData.role)
              dispatch(actions.addMessage("popup.title.user.save.success", null, 'text', 'dialog'));
           }).catch(res => {   
               dispatch(adminSaveUserFail());
               dispatch(actions.addMessage("popup.title.user.save.fail", null, 'text', 'dialog'));
          });      
            
    }

}
export function adminSaveNewUser(userData, messages) {
    return dispatch => {
        dispatch(adminSaveNewUserStart());
        console.log(userData);
        window.flow.newUser(userData.username, userData.email, {usertype: 1, password: userData.password, metadata: {first_name: userData.first_name, last_name: userData.last_name}}).then((res) => {
            let user = {
                ...res.user.data,
                email: res.user.email,
                first_name: res.user.first_name,
                last_name: res.user.last_name,
            };
            user.role = userData.role;
            dispatch(adminSaveNewUserSuccess(user));
            window.flow.grantingUserSetRole(res.groupid, res.userid, userData.role).then((res1) => {
                //dispatch(adminSaveUserSuccess(res1))
            });
        }).catch(res => {
            console.log(res);
            dispatch(adminSaveNewUserFail());
            let msg = '';
            if(res.resultid && res.resultid > 1 && res.resultid < 10) {
                msg = "popup.admin.user.create.error."+res.resultid;
            }
            dispatch(actions.addMessage("popup.title.user.create.fail", msg, 'text', 'dialog'));
        });
    }
}

export function adminDeleteUser(id, messages) {
    return dispatch => {
        dispatch(adminDeleteUserStart());
        console.log(id);
        window.flow.delUser(id).then((res) => {

            dispatch(adminDeleteUserSuccess(id));
        }).catch(res => {
            console.log(res);
            if(res.indexOf('deleted user') !== -1) {
                dispatch(adminDeleteUserSuccess(id));
            } else {
                dispatch(adminDeleteUserFail());
                dispatch(actions.addMessage("popup.title.user.delete.fail", null, 'text', 'dialog'));
            }

        });

    }
}
